import {
    createStore
} from 'vuex';

import actions from '@/FreeTrial/store/actions.js';
import state from '@/FreeTrial/store/state.js';
import mutations from '@/FreeTrial/store/mutations.js';
import getters from '@/FreeTrial/store/getters.js';

export const ftStore = createStore({
    state,
    mutations,
    actions,
    getters,
    strict: process.env.NODE_ENV !== 'production'
})
